import React, { useMemo, useState } from 'react';
import { Dropdown } from 'semantic-grab-ui/src';
import './SingleSearch.scss';

interface Option {
  label: string;
  value: string;
}

interface Props {
  onChange: (value?: string) => void;
  title?: string;
  placeholder: string;
  initialValue?: string;
  value?: string; // Add value prop for controlled component
  options: Option[];
  width?: string;
  height?: string;
  addNone?: boolean;
  searchPlaceholder?: string;
}

const ALL = 'All';

const SingleSearch: React.FC<Props> = (props) => {
  const [internalChosen, setInternalChosen] = useState<string | undefined>(props.initialValue);

  // Use value prop if provided (controlled), otherwise use internal state (uncontrolled)
  let chosen = props.value !== undefined ? props.value : internalChosen;

  // Convert options to semantic-ui format
  const dropdownOptions = useMemo(() => {
    const baseOptions = props.options.map(option => ({
      key: option.value,
      value: option.value,
      text: option.label,
    }));

    if (props.addNone) {
      return [
        { key: ALL, value: ALL, text: ALL },
        ...baseOptions,
      ];
    }

    return baseOptions;
  }, [props.options, props.addNone]);

  const handleChange = (event: any, data: any) => {
    const selectedValue = data.value === ALL ? undefined : data.value;

    // Only update internal state if not controlled
    if (props.value === undefined) {
      setInternalChosen(selectedValue);
    }

    props.onChange(selectedValue);
  };

  return (
    <div>
      {props.title && (
        <div style={{ margin: '5px 2px', fontWeight: 600, width: props.width }}>
          {props.title}
        </div>
      )}

      <Dropdown
        className="single-search-dropdown"
        placeholder={props.searchPlaceholder || props.placeholder}
        search
        selection
        clearable={props.addNone}
        options={dropdownOptions}
        value={chosen}
        onChange={handleChange}
        style={{
          width: props.width,
          height: props.height,
          borderColor: 'rgb(191, 191, 191)',
        }}
      />
    </div>
  );
};

export default SingleSearch;
